<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps({
  items: { type: Array, default: () => [] },
  open: { type: Boolean, default: false },
});

const { t } = useI18n();
const expanded = ref(true);
const panelClass = computed(() =>
  expanded.value ? 'w-[min(360px,calc(100vw-2rem))]' : 'w-[66px]'
);
const toggleLabel = computed(() =>
  expanded.value
    ? t('SALES_PARTIES.CERTIFICATES.COLLAPSE')
    : t('SALES_PARTIES.CERTIFICATES.EXPAND')
);
</script>

<template>
  <div class="contents">
    <aside
      v-if="open"
      aria-live="polite"
      data-test="sales-party-certificate-feedback"
      class="fixed right-4 top-24 z-50 overflow-hidden rounded-lais border border-lais-border bg-white shadow-lg transition-[width]"
      :class="panelClass"
    >
      <div class="flex items-center gap-2 p-3">
        <button
          type="button"
          :aria-label="toggleLabel"
          class="grid size-8 shrink-0 place-items-center rounded-lais-sm text-lais-text-muted hover:bg-lais-bg-soft focus-visible:outline-none focus-visible:shadow-lais-focus"
          data-test="sales-party-certificate-feedback-toggle"
          @click="expanded = !expanded"
        >
          <span
            aria-hidden="true"
            :class="
              expanded ? 'i-lucide-chevrons-left' : 'i-lucide-chevrons-right'
            "
          />
        </button>
        <div v-if="expanded" class="min-w-0 flex-1 space-y-2">
          <div
            v-for="item in items"
            :key="item.doc"
            class="flex items-center gap-2 text-sm text-lais-text-body"
          >
            <span
              aria-hidden="true"
              class="size-5 shrink-0"
              :class="
                item.status === 'loading'
                  ? 'i-lucide-loader-circle animate-spin text-lais-text-muted'
                  : item.status === 'success'
                    ? 'i-lucide-check text-green-600'
                    : 'i-lucide-x text-red-600'
              "
            />
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
    </aside>
  </div>
</template>
